import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/booking.vue'
wx.createPage(MiniProgramPage)